export const styles = {
  base: 'p-3 rounded-xl border border-gray-300 flex flex-col gap-y-4 relative',
  poster: 'h-41.5 overflow-hidden rounded-lg relative flex-shrink-0',
};
